export const CustomNUSAEvents = {
  /**
   * This event is dispatched when NUSA calls the window.NUSA_onProcessingFinishedForElement function.
   */
  FINISHED_PROCESSING: 'finishedProcessing',
};
